import { cn } from '@/lib/cn';

export function Brand({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <img src="/favicon.svg" alt="" width="32" height="32" className="shrink-0" />
      <div className="whitespace-nowrap leading-tight">
        <p className="text-[15px] font-semibold tracking-tight">Los Gochitos</p>
        <p className="mt-0.5 text-xs text-texto-suave">Mini Market</p>
      </div>
    </div>
  );
}
